import React, { useEffect } from "react";
import HeroSection from "./components/HeroSection";
import FooterSection from "./components/FooterSection";
import DemoBookingSection from "./components/DemoBookingSection";
import TestimonialsSection from "./components/TestimonialsSection";
/* import SecuritySection from "./components/SecuritySection";
import PricingSection from "./components/PricingSection"; */
import FeatureShowcase from "./components/FeatureShowcase";
import DualModeToggle from "./components/DualModeToggle";
import ProblemSection from "./components/ProblemSection";
import Header from "../../components/ui/Header";

interface StructuredData {
  "@context": string;
  "@type": string;
  name: string;
  applicationCategory: string;
  description: string;
  operatingSystem: string;
}

// interface StructuredData {
//   "@context": string;
//   "@type": string;
//   name: string;
//   applicationCategory: string;
//   description: string;
//   operatingSystem: string;
//   offers: {
//     "@type": string;
//     price: string;
//     priceCurrency: string;
//     priceSpecification: {
//       "@type": string;
//       price: string;
//       priceCurrency: string;
//       unitText: string;
//     };
//   };
//   aggregateRating: {
//     "@type": string;
//     ratingValue: string;
//     ratingCount: string;
//     bestRating: string;
//   };
//   provider: {
//     "@type": string;
//     name: string;
//     url: string;
//   };
// }

const LandingPage: React.FC = () => {
  useEffect(() => {
    // Set page title
    document.title =
      "KnowTran - Transform Your Educational Institution | School & College Management System";

    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute(
        "content",
        "Transform your educational institution with KnowTran's comprehensive management platform. Streamlined student registration, accurate attendance tracking, and efficient fee management - all in one modern solution."
      );
    }

    // Add structured data for SEO

    const structuredData: StructuredData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "KnowTran",
      applicationCategory: "EducationApplication",
      description: "Education management software for schools and colleges.",
      operatingSystem: "Web",
      // "@context": "https://schema.org",
      // "@type": "SoftwareApplication",
      // name: "KnowTran",
      // applicationCategory: "EducationApplication",
      // description:
      //   "Comprehensive education management system for schools and colleges",
      // operatingSystem: "Web, iOS, Android",
      // offers: {
      //   "@type": "Offer",
      //   price: "2.50",
      //   priceCurrency: "USD",
      //   priceSpecification: {
      //     "@type": "UnitPriceSpecification",
      //     price: "2.50",
      //     priceCurrency: "USD",
      //     unitText: "per student per month",
      //   },
      // },
      // aggregateRating: {
      //   "@type": "AggregateRating",
      //   ratingValue: "4.9",
      //   ratingCount: "2847",
      //   bestRating: "5",
      // },
      // provider: {
      //   "@type": "Organization",
      //   name: "KnowTran Technologies",
      //   url: "https://knowtran.com",
      // },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(structuredData);
    document.head?.appendChild(script);

    // Cleanup function
    return () => {
      if (document.head?.contains(script)) {
        document.head?.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/* Hero Section */}
      <HeroSection />

      {/* Problem/Solution Section */}
      <ProblemSection />

      {/* Dual Mode Toggle */}
      <DualModeToggle />

      {/* Feature Showcase */}
      <FeatureShowcase />

      {/* Security Section */}
      {/* <SecuritySection /> */}

      {/* Testimonials */}
      <TestimonialsSection />

      {/* Pricing */}
      {/* <PricingSection /> */}

      {/* Demo Booking */}
      <DemoBookingSection />

      {/* Footer */}
      <FooterSection />
    </div>
  );
};

export default LandingPage;
